import React, { useState } from "react";
import {
  Grid,
  Box,
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { ViewMoreButton } from "../Common";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const standingsBG = require("../../../assets/images/standings-card-bg.png");

const StandingsCard = ({ potyData }) => {
  const [value, setValue] = useState(0);
  const [season, setSeason] = useState("POTY");
  const [points, setPoints] = useState([]);
  const [potyLeaderboard, setPotyLeaderboard] = useState([]);
  const navigate = useNavigate();

  const getPoints = (data, id) => {
    if (data.projected) {
      return points[id];
    } else {
      return "-";
    }
  };

  const columns = [
    {
      name: "Rank",
      selector: (row, params) => params + 1,
      width: "20%",
    },
    {
      name: "Player",
      selector: (row) => row.name,
      width: "50%",
    },
    {
      name: "Points",
      selector: (row, params) => parseFloat(row?.points).toFixed(2),
      width: "30.33333333333333%",
    },
  ];

  const data = [
    {
      id: 1,
      rank: "1",
      player: "DANISH FEROZ",
      points: "653.46",
    },
    {
      id: 2,
      rank: "2",
      player: "ADIL HAJI",
      points: "639.50",
    },
    {
      id: 3,
      rank: "3",
      player: "KHALID SIDDIQI",
      points: "636.67",
    },
    {
      id: 4,
      rank: "4",
      player: "ASIF HUSSAIN",
      points: "623.17",
    },
    {
      id: 5,
      rank: "5",
      player: "TARIQ ALLAWALA",
      points: "601.67",
    },
    {
      id: 6,
      rank: "6",
      player: "ASIF HUSSAIN",
      points: "623.17",
    },
  ];

  const lclData = [
    {
      id: 1,
      rank: "1",
      player: "ASIF HUSSAIN",
      points: "623.17",
    },
    {
      id: 2,
      rank: "2",
      player: "TARIQ ALLAWALA",
      points: "601.67",
    },
    {
      id: 3,
      rank: "3",
      player: "ASIF HUSSAIN",
      points: "623.17",
    },
    {
      id: 4,
      rank: "4",
      player: "DANISH FEROZ",
      points: "653.46",
    },
    {
      id: 5,
      rank: "5",
      player: "ADIL HAJI",
      points: "639.50",
    },
    {
      id: 6,
      rank: "6",
      player: "KHALID SIDDIQI",
      points: "636.67",
    },
  ];

  const smpData = [
    {
      id: 1,
      rank: "1",
      player: "ASIF HUSSAIN",
      points: "623.17",
    },
    {
      id: 2,
      rank: "2",
      player: "DANISH FEROZ",
      points: "653.46",
    },
    {
      id: 3,
      rank: "3",
      player: "ADIL HAJI",
      points: "639.50",
    },
    {
      id: 4,
      rank: "4",
      player: "ASIF HUSSAIN",
      points: "623.17",
    },
    {
      id: 5,
      rank: "5",
      player: "TARIQ ALLAWALA",
      points: "601.67",
    },
    {
      id: 6,
      rank: "6",
      player: "KHALID SIDDIQI",
      points: "636.67",
    },
  ];

  const dmpData = [
    {
      id: 1,
      rank: "1",
      player: "TARIQ ALLAWALA",
      points: "601.67",
    },
    {
      id: 2,
      rank: "2",
      player: "DANISH FEROZ",
      points: "653.46",
    },
    {
      id: 3,
      rank: "3",
      player: "ASIF HUSSAIN",
      points: "623.17",
    },
    {
      id: 4,
      rank: "4",
      player: "ASIF HUSSAIN",
      points: "623.17",
    },
    {
      id: 5,
      rank: "5",
      player: "KHALID SIDDIQI",
      points: "636.67",
    },
    {
      id: 6,
      rank: "6",
      player: "ADIL HAJI",
      points: "639.50",
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "40px", // override the row height
      },
    },
    headCells: {
      style: {
        paddingLeft: "15px", // override the cell padding for head cells
        paddingRight: "8px",
        fontSize: "1.2em",
        fontWeight: "700",
        // justifyContent: "center",
      },
    },
    cells: {
      style: {
        paddingLeft: "15px", // override the cell padding for data cells
        paddingRight: "8px",
        fontWeight: "400",
        fontSize: ".9em",
        justifyContent: "left",
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row) => row.id % 2 !== 0,
      style: {
        backgroundColor: "rgba(41, 48, 69, 0.05)",
        color: "#000000",
      },
    },
  ];

  const useStyles = makeStyles({
    playerprofilebtn: {
      backgroundColor: "#06623B !important",
      color: "#FFF !important",
      width: 140,
      height: 40,
      borderRadius: 10,
    },
    cardHeader: {
      backgroundColor: "#06623b",
      height: 75,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px",
      "& ~ div": {
        marginBottom: 1,
        marginTop: "-10px",
        borderTopLeftRadius: "10px",
        borderTopRightRadius: "10px",
        "& .rdt_Table": {
          paddingLeft: "10px",
          paddingRight: "10px",
        },
      },
    },
    seasonTabs: {
      backgroundColor: "#F1F2F3 !important",
      padding: "0px 0px 0px 0px !important",
      borderRadius: "25px !important",
      "& > ": {
        backgroundColor: "#F1F2F3 !important",
        borderRadius: "25px !important",
      },
    },
    seasonBtn: {
      backgroundColor: "#F1F2F3 !important",
      border: "none !important",
      color: "#000000 !important",
      margin: 3,
      fontSize: "0.8em !important",
      borderRadius: "25px !important",
      fontWeight: "700 !important",
    },
    activeSeasonBtn: {
      border: "1px solid #F1F2F3 !important",
      backgroundColor: "white !important",
      zIndex: "1 !important",
      color: "#06623B !important",
      // fontWeight: "700 !important"
    },
    datatableSibiling: {
      "& ~ div > div": {
        // Width
        "&::-webkit-scrollbar": {
          width: "5px",
        },
        // Track
        "&::-webkit-scrollbar-track": {
          background: " #C4C4C4",
          marginTop: "25px",
        },
        // Handle
        "&::-webkit-scrollbar-thumb": {
          background: "#06623B",
          borderTop: "50px solid #C4C4C4",
        },
        // Handle on Hover
        "&::-webkit-scrollbar-thumb:hover": {
          background: "#06623B",
        },
      },
    },
  });

  const showAll = () => {
    navigate("/poty-leaderboard");
  };

  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        {/* <Card> */}
        <CardContent
          sx={{
            padding: 0,
            boxShadow:
              "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
            paddingBottom: "5px !important",
            borderBottomLeftRadius: "5px",
            borderBottomRightRadius: "5px",
          }}
        >
          <Box className={`${classes.cardHeader} ${classes.datatableSibiling}`}>
            <Box gutterBottom>
              <ButtonGroup
                className={classes.seasonTabs}
                variant="contained"
                aria-label="outlined primary button group"
                size="large"
                fullWidth
              >
                <Button
                  className={clsx(classes.seasonBtn, {
                    [classes.activeSeasonBtn]: season === "POTY",
                  })}
                  onClick={() => setSeason("POTY")}
                >
                  POTY
                </Button>
                {/* <Button
                  className={clsx(classes.seasonBtn, {
                    [classes.activeSeasonBtn]: season === "LCL",
                  })}
                  onClick={() => setSeason("LCL")}
                >
                  LCL
                </Button>
                <Button
                  className={clsx(classes.seasonBtn, {
                    [classes.activeSeasonBtn]: season === "SMP",
                  })}
                  onClick={() => setSeason("SMP")}
                >
                  SMP
                </Button>
                <Button
                  className={clsx(classes.seasonBtn, {
                    [classes.activeSeasonBtn]: season === "DMP",
                  })}
                  onClick={() => setSeason("DMP")}
                >
                  DMP
                </Button> */}
              </ButtonGroup>
            </Box>
            {/* <Typography variant="body2" fontWeight={700} color="#FFF" sx={{ marginTop: '15px' }}>
                         {season} Standings 
                        </Typography> */}
          </Box>

          <Box>
            <DataTable
              columns={columns}
              data={potyData?.potyData}
              // data={
              //   season == "POTY"
              //     ? potyData?.potyData
              //     : season == "LCL"
              //     ? lclData
              //     : season == "SMP"
              //     ? smpData
              //     : dmpData
              // }
              customStyles={customStyles}
              conditionalRowStyles={conditionalRowStyles}
              fixedHeader={true}
              fixedHeaderScrollHeight={"220px"}
            />
          </Box>

          <Grid container>
            <Grid
              item
              xs={11.5}
              sx={{ mt: 2 }}
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <ViewMoreButton
                text="Show All"
                buttonBG="#06623b"
                color="alternate"
                float="right"
                variant="filled"
                onClickCB={() => showAll()}
              />
            </Grid>
          </Grid>
        </CardContent>
        {/* </Card> */}
      </Grid>
    </Grid>
  );
};

export default StandingsCard;
